export const modalFXMenu = function () {

  var elements = {
      target: 'data-nav',
      active: 'is-active',
      button: '.modal-nav',
      close: '.nav-close',
      buttonClose: '.nav-button-close',
      background: '.nav-background'
  };

  var onClickEach = function (selector, callback) {
      var arr = document.querySelectorAll(selector);
      arr.forEach(function (el) {
          el.addEventListener('click', callback);
      });
  };

  var events = function () {
      onClickEach(elements.button, openModal);
      onClickEach(elements.close, closeModal);
      onClickEach(elements.buttonClose, closeAll);
      onClickEach(elements.background, closeModal);

      // Close all modals if ESC key is pressed
      document.addEventListener('keyup', function (key) {
          if (key.keyCode === 27) {
              closeAll();
          }
      });
      //ページ再訪時はモーダルを閉じる
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            closeAll();
        }
      });


  };

  var closeAll = function () {
      console.log('close all');
      var openModal = document.querySelectorAll('.' + elements.active);
      openModal.forEach(function (modal) {
          modal.classList.remove(elements.active);
      });
      const menuBtn = document.querySelector('.menu-link');
      if (menuBtn && menuBtn.classList.contains('is-open')) {
          menuBtn.classList.remove('is-open');
          menuBtn.classList.remove('nav-button-close');
          menuBtn.classList.add('modal-nav');
          document.getElementById('mobile__menu').classList.remove('is-active');


      }
      unFreeze();
  };

  var toggleMenuBtn = function () {
      const menuBtn = document.querySelector('.menu-link');
      const target = menuBtn.getAttribute('data-nav');
      const modal = document.getElementById(target);
      if (menuBtn) {
          if (menuBtn.classList.contains('is-open')) {
              menuBtn.classList.remove('is-open');
              menuBtn.classList.remove('nav-button-close');
              menuBtn.classList.add('modal-nav');
              modal.classList.remove('is-active');
              unFreeze();
          } else {
              menuBtn.classList.add('is-open');
              menuBtn.classList.add('nav-button-close');
              menuBtn.classList.remove('modal-nav');
          }
      }
  };

  var openModal = function () {
      var modal = this.getAttribute(elements.target);
      freeze();
      document.getElementById(modal).classList.add(elements.active);
      const gfNavHeight = document.getElementById('gf_nav') ? document.getElementById('gf_nav').clientHeight : 0;
      document.getElementById(modal).style.bottom = `${gfNavHeight}px`;

      toggleMenuBtn();
  };

  var closeModal = function (modalElement=null) {

      const modal = modalElement?modalElement:this.parentElement.id;
      document.getElementById(modal).classList.remove(elements.active);
      unFreeze();
      toggleMenuBtn();
  };

  // Freeze scrollbars
  var freeze = function () {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflowY = "scroll";
  };

  var unFreeze = function () {
      document.documentElement.style.overflow = "";
      document.body.style.overflowY = "";
  };

  return {
      init: function () {
          events();
          const modal = document.getElementById('mobile__menu');
          if(modal){
            const anchors =  modal.querySelectorAll(`a[href*="#"]`);
            anchors.forEach((v,k) => {
              v.addEventListener('click',function(){
                console.log(`click`);
                setTimeout(() => {
                  closeModal(`mobile__menu`);
                }, 200);
              });
            });
          }
      }
  };
};


